"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactStripeElements = require("react-stripe-elements");

var _ResponsivePage = _interopRequireDefault(require("../../01_atoms/ResponsivePage"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _PaymentPaneWidget = _interopRequireDefault(require("../../03_organisms/PaymentPaneWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Define component here to avoid losing focus on forms because of anonymous comp
var BasicPageLayout = function BasicPageLayout(props) {
  var onBack = props.onBack,
      t = props.translator;
  return /*#__PURE__*/_react["default"].createElement(_reactStripeElements.Elements, null, /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Payment'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_PaymentPaneWidget["default"], props)));
};

var CreditCardPaymentPageUI = /*#__PURE__*/function (_Component) {
  _inherits(CreditCardPaymentPageUI, _Component);

  var _super = _createSuper(CreditCardPaymentPageUI);

  function CreditCardPaymentPageUI(props) {
    var _this;

    _classCallCheck(this, CreditCardPaymentPageUI);

    _this = _super.call(this, props);
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.state = {
      cardComplete: false
    };
    return _this;
  }

  _createClass(CreditCardPaymentPageUI, [{
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stripe) {
        var _this$props, email, _this$props$onToken, onToken, _yield$stripe$createT, token;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, email = _this$props.email, _this$props$onToken = _this$props.onToken, onToken = _this$props$onToken === void 0 ? function () {} : _this$props$onToken; // Create Stripe token

                _context.next = 3;
                return stripe.createToken({
                  name: email
                });

              case 3:
                _yield$stripe$createT = _context.sent;
                token = _yield$stripe$createT.token;
                // console.log(`Stripe token generated: ${token}`);
                onToken(email, token);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      var _this$state$cardCompl = this.state.cardComplete,
          cardComplete = _this$state$cardCompl === void 0 ? false : _this$state$cardCompl;
      return cardComplete;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          translatorForNamespace = _this$props2.translatorForNamespace,
          payAmount = _this$props2.payAmount,
          error = _this$props2.error,
          _this$props2$onBack = _this$props2.onBack,
          onBack = _this$props2$onBack === void 0 ? function () {} : _this$props2$onBack,
          numberOfPassengers = _this$props2.numberOfPassengers;
      var t = translatorForNamespace('CreditCardPaymentPageUI');
      var elementsOptions = {
        style: {
          base: {
            fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
            margin: '0',
            outline: '0',
            WebkitAppearance: 'none',
            tapHighlightColor: 'rgba(255,255,255,0)',
            lineHeight: '1.21428571em',
            padding: '.67857143em 1em',
            fontSize: '1em',
            background: '#fff',
            border: '1px solid rgba(34,36,38,.15)',
            color: 'rgba(0,0,0,.87)',
            borderRadius: '.28571429rem',
            boxShadow: '0 0 0 0 transparent inset',
            transition: 'color .1s ease,border-color .1s ease'
          },
          invalid: {
            color: '#c23d4b'
          }
        }
      };
      var widgetProps = {
        translator: t,
        onBack: onBack,
        canSubmit: function canSubmit() {
          return _this2.canSubmit();
        },
        submit: function submit() {
          return _this2.submit.apply(_this2, arguments);
        },
        setState: function setState() {
          return _this2.setState.apply(_this2, arguments);
        },
        numberOfPassengers: numberOfPassengers,
        payAmount: payAmount,
        elementsOptions: elementsOptions,
        error: error
      }; // We need to use two different Elements components to manage responsiveness with Stripe
      // cf https://github.com/stripe/react-stripe-elements/issues/479

      return /*#__PURE__*/_react["default"].createElement(_ResponsivePage["default"], _extends({
        wideScreenComponent: BasicPageLayout,
        mobileComponent: BasicPageLayout,
        threshold: _semanticUiReact.Responsive.onlyMobile.maxWidth
      }, widgetProps));
    }
  }]);

  return CreditCardPaymentPageUI;
}(_react.Component);

var _default = CreditCardPaymentPageUI;
exports["default"] = _default;